import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { ProfilesList } from '@widgets/dating/components';

export const Route = createFileRoute('/dating/')({
  component: Component,
});

export default function Component() {
  return (
    <Page style={{ padding: 0, paddingBottom: 8 }}>
      <ProfilesList />
    </Page>
  );
}
